module.exports = __webpack_public_path__ + "static/media/day12.workshop.e05ce77b.md";